import { get } from '../request';
import { APP_CONFIG } from '@/config';
import { FeatureSwitches } from '@/@types/featureSwitch';
import { ApiEndpoints } from '@/api/apiEndpoints.constant';

export const getFeatureSwitches = async (): Promise<FeatureSwitches> => {
  return await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.featureSwitches}`);
};
